import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { HttpService } from './http.service';
import { SharedService } from './shared.service';
import { DictionaryService } from './dictionary.service';

@Injectable()
export class UserService {
  public userId: number = null;
  public userData: any = {};
  public userDataSignature: string = null;
  public networkData: any = null;
  public userRoles: Array<string> = [];
  public activeNetworks: Array<any> = [];
  public aboutToChangeNetwork = false;

  constructor(
    public router: Router,
    public httpService: HttpService,
    public sharedService: SharedService,
    public dictionaryService: DictionaryService
  ) {
    this.initUserData();
    this.sharedService.getMessagesBus().subscribe((response) => {
      if (response.type === 'LOGIN' || response.type === 'LOGOUT') {
        this.initUserData();
      }
    });
  }

  initUserData() {
    if (localStorage.getItem('userId')) {
      this.userId = parseInt(localStorage.getItem('userId'));
      this.userData = JSON.parse(localStorage.getItem('userData'));
      this.userDataSignature = localStorage.getItem('userDataSignature');
      const isUserDataModified =
        this.userDataSignature !==
        this.sharedService.hashString(localStorage.getItem('userData') + localStorage.getItem('userData'));
      if (isUserDataModified) {
        localStorage.removeItem('userId');
        localStorage.removeItem('userData');
        localStorage.removeItem('userDataSignature');
        this.router.navigate(['/login']);
      }
    } else {
      this.userId = null;
      this.userData = {};
      this.userDataSignature = null;
    }
  }

  isLoggedIn() {
    return (
      !this.sharedService.isEmpty(this.userData) &&
      !this.sharedService.isEmpty(this.userDataSignature) &&
      !this.sharedService.isEmpty(this.networkData)
    );
  }

  saveNetworkData(networkData: any) {
    this.networkData = networkData;
    this.sharedService.sendMessage('NETWORK_DATA_UPDATED');
    localStorage.setItem(
      'networkData',
      JSON.stringify({
        networkId: networkData.networkId,
      })
    );
  }

  logout() {
    this.httpService.post('logout/index').subscribe((response: any) => {
      localStorage.removeItem('userId');
      localStorage.removeItem('userData');
      localStorage.removeItem('userDataSignature');
      this.sharedService.deleteAllCookies();
      this.networkData = null;
      this.initUserData();
      this.router.navigate(['/login']);
      this.sharedService.sendMessage('LOGOUT');
    });
  }

  changeNetwork(network: any, forcedChange: boolean = false) {
    const params: any = { networkId: network.networkId };
    const request: any = this.httpService.post('networks_management/setNetwork', params);
    this.networkData = network;
    request.subscribe((response: any) => {
      this.sharedService.showFlashMessage(
        this.dictionaryService.get('NETWORK_HAS_BEEN_CHANGED_SUCCESSFULLY'),
        'success'
      );
      this.sharedService.sendMessage('NETWORK_IS_CHANGING', {
        networkId: response.networkId,
        forcedChange: forcedChange,
      });
      this.sharedService.clearLocalStorageGridFilters();
    });
    this.aboutToChangeNetwork = false;
    this.sharedService.changeNetworkTo = {};
    return request;
  }

  changeNetworkIfNeeded(response: any) {
    if (response.networkData && response.networkData.networkChanged) {
      this.changeNetwork(response.networkData, true);
    }
  }

  getFeatureState(featureName: string) {
    return this.networkData !== null ? !!+this.networkData[featureName] : false;
  }

  isAdmin() {
    return this.userData && this.userData.userType ? this.userData.userType === 'admin' : false;
  }

  isPublisher() {
    return this.userData && this.userData.userType ? this.userData.userType === 'publisher' : false;
  }

  isCedatoPublisher(data: any = {}) {
    let resp = false;

    if (!data.userType) {
      resp =
        this.userData && this.userData.userType && this.networkData
          ? (this.userData.userType === 'publisher' && this.getFeatureState('publisher_hb')) ||
            this.userData.userType === 'cedatopub'
          : false;
    } else {
      resp = this.getFeatureState('publisher_hb') && data.userType && data.userType === 'publisher';
    }

    if (resp) { this.userData.userType = 'cedatopub'; }

    return resp;
  }

  isCedatoPublisherNetwork() {
    return this.networkData ? +this.networkData.publisher_io === 1 : false;
  }

  isHBNetworkCedatoPublishers() {
    return this.networkData ? +this.networkData.networkId === 607626335 : false;
  }

  isPublisherNetwork() {
    return this.networkData ? this.networkData.network_type === 'publisher' : false;
  }

  isCedatoXMarketplace() {
    return this.networkData ? this.networkData.cedatox_marketplace === '1' : false;
  }

  isAllowedCx2Cx() {
    return this.networkData ? +this.networkData.cedatox_marketplace === 1 || this.getFeatureState('Cx2Cx') : false;
  }

  getUserRoleState(userRole: string) {
    return userRole && this.userRoles ? this.userRoles.includes(userRole) : false;
  }

  getDefaultDomainName() {
    if (this.networkData.network_exclusive_domain && this.networkData.network_exclusive_domain.domain) {
      return this.networkData.network_exclusive_domain.domain;
    } else {
      return this.networkData.network_domains &&
        this.networkData.network_domains.length &&
        this.networkData.network_domains[0].domain
        ? this.networkData.network_domains[0].domain
        : '';
    }
  }

  getDefaultRoute() {
    let defaultRoute = '/supply/all';
    if (this.isCedatoPublisher()) {
      defaultRoute = '/inventory/all';
    } else if (this.isPublisher()) {
      defaultRoute = '/inventory-all';
    }
    return defaultRoute;
  }

  isOem() {
    return this.networkData ? this.networkData.network_type !== 'agg' && this.networkData.networkId !== '368531133' && this.networkData.networkId !== '381804308'  : false;
  }
}
